// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"796b10be","89":"2d04187b","455":"14e61dc8","591":"f33e0782","647":"0adda82d","728":"0adda82d"}[chunkId] + ".chunk.css";
};